<template>
  <Modal class="modal modal--mob modal-radio-buttons modal-net-worth"  :closable="false">
    <template #header>
      <h2>{{ $t('form_fields.net_worth_label') }}</h2>
    </template>
    <template #body>
      <div class="relative custom-select-option">
        <select class="input input--primary" v-model="netWorth">
          <option v-for="(n, index) in netWorthOptions" :key="index" :value="n.value" :selected="n.value === netWorth">
            {{ $t('form_fields.' + n.label) + ' €' }}
          </option>
        </select>

        <svg xmlns="http://www.w3.org/2000/svg" width="9.29" height="6">
          <path data-name="Icon awesome-angle-down"
                d="M4.154 5.795.201 1.845a.694.694 0 0 1 0-.985l.66-.655a.694.694 0 0 1 .985 0l2.8 2.8 2.8-2.8a.694.694 0 0 1 .985 0l.656.656a.694.694 0 0 1 0 .985l-3.95 3.95a.691.691 0 0 1-.982 0Z"></path>
        </svg>

      </div>
      <div class="button-wrapper w-100 mt">
        <button type="submit" :disabled="!valid || working" @click="submit" class="button button--primary w-100">
          {{ $t('settings.save') }}
        </button>
        <p class="u-text-center mt mb0"><a @click="skipModal">{{$t('credits.skip_for_now')}}</a></p>
      </div>

    </template>
    <!-- <template #footer>

    </template> -->
  </Modal>
</template>

<script>

import Modal from "@/components/generic/Modal";
import AuthenticatedMixin from "@/mixins/AuthenticatedMixin";
import {netWorth} from "@/service/forms";
import InArray from "@/service/helpers/InArray";
import PluckProperty from "@/service/helpers/PluckProperty";
import toastr from "toastr";
import {updateProfile} from "@/service/user";
import { GTM_EVENT_DATING_NET_WORTH_MODAL, GTM_EVENT_DATING_NET_WORTH_SUCCESS, GTM_EVENT_DATING_NET_WORTH_MODAL_SKIP} from "@/service/gtm/types";
import {pushDataLayer} from "@/service/gtm";
import {TYPE_GENDER_MALE} from "@/types/user";
import {NET_WORTH_MODAL_KEY, NET_WORTH_MODAL_SILENCE_DURATION} from "@/service/popups/config";
import {setAsDisplayed} from "../../../service/popups";

export default {
  name: "PreActionNetWorth",
  mixins: [AuthenticatedMixin],
  components: {Modal},
  data() {
    return {
      working: false,
      netWorth: null,
      netWorthOptions: [],
    }
  },
  computed:{
    valid(){
      return this.netWorth !== null
    }
  },
  methods: {
    skipModal(){
      this.$emit('success')
      pushDataLayer(GTM_EVENT_DATING_NET_WORTH_MODAL_SKIP, this.auth.user)
    },
    isValid() {
      return InArray(this.netWorth, PluckProperty(this.netWorthOptions, 'value'))
    },
    async submit() {

      if (!this.isValid()) {
        return
      }

      this.working = true

      try {
        await updateProfile({net_worth: this.netWorth})
        toastr.success(this.$i18n.t('profile.edit.profile_changed'))
        this.working = false
        pushDataLayer(GTM_EVENT_DATING_NET_WORTH_SUCCESS, this.auth.user)
        this.$emit('success')
      } catch {
        toastr.error(this.$i18n.t('credits.error_processing'))
        this.working = false
      }

    }

  },
  created() {
    this.netWorthOptions = netWorth
    this.TYPE_GENDER_MALE = TYPE_GENDER_MALE

  },
  mounted() {
    this.netWorth = this.auth.user.net_worth ?? this.netWorthOptions[0].value
    pushDataLayer(GTM_EVENT_DATING_NET_WORTH_MODAL, this.auth.user)
    setAsDisplayed(NET_WORTH_MODAL_KEY, NET_WORTH_MODAL_SILENCE_DURATION)

  }

}
</script>

<style lang="scss" scoped>

.custom-select-option {
  svg {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translate(0, -50%);
    pointer-events: none;
  }
}
</style>

<style lang="scss">
  .modal-net-worth {
    .modal-footer {
      padding: 0!important;
    }
  }
</style>